import { ViewModel,View } from "binder"
import  { NotAuthenticatedUserMainWindowView } from "./notAuthenticatedUserMainWindow-view"
import { UserMainWindowViewModel } from "../userMainWindow-viewModel";

export class NotAuthenticatedUserMainWindowViewModel extends UserMainWindowViewModel{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new NotAuthenticatedUserMainWindowView();
    }
    public getTypeId(): string {
        return "VM-DE90F1BC-16AE-474A-B447-3E487C70E7B0"
    }
}
